<template>
  <v-container class="px-1" text-xs-center>
    <v-card class="pa-2">
      <h3 class="center mg-wrap categoryTitle">
        របាយការណ៏សាលារៀនឯកជន និងមត្តេយ្យសិក្សាសហគមន៏
      </h3>
      <v-row row wrap>
        <v-col xs12 sm3 md3>
          <v-select
            class="questionTitle pr-2"
            v-if="a_code"
            :items="academics"
            v-model="a_code"
            outline
            label="ឆ្នាំសិក្សា"
            id="a_code"
          >
          </v-select>
        </v-col>
        <v-col xs12 sm3 md3>
          <v-select
            class="questionTitle pr-2"
            label="ឈ្មោះរាជធានី ខេត្ត"
            :items="province"
            item-text="pKh"
            item-value="pid"
            outline
            ref="pro"
          >
          </v-select>
        </v-col>
        <v-col xs12 sm6 md6>
          <v-select
            class="questionTitle pr-2"
            label="ប្រភេទរបាយការណ៏"
            :items="reportNotInDBPriv"
            item-text="text"
            item-value="value"
            outline
            ref="report_type"
            single-line
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col align="center" justify="center">
          <v-btn color="info questionTitle" @click.native="show_list(0)" small
            >សាលាមិនរក្សាទុក</v-btn
          >
        </v-col>
        <v-col align="center" justify="center">
          <v-btn color="info questionTitle" @click.native="show_list(1)" small
            >សាលាត្រូវសំអាតទិន្នន័យ</v-btn
          >
        </v-col>
        <v-col align="center" justify="center">
          <v-btn color="info questionTitle" @click.native="show_list(2)" small
            >សាលាបញ្ចូលរួច</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col xs12 md12>
          <not-entry :dataTable="noEntryDataTable"></not-entry>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import notInSystem from "@/components/textbook/reportTextbook.vue";
// get the functions from wash for getting report==>will replace in future
import winsModule from "@/store/modules/wins/index";
import { reportNotInDBPriv } from "@/utils/ascf/reportConfig.js";

export default {
  components: {
    "not-entry": notInSystem,
  },
  data() {
    return {
      academics: this.$store.state.uiControl.academics,
      a_code: this.$store.state.uiControl.academics[0].value,
      reportNotInDBPriv: reportNotInDBPriv,
    };
  },
  watch: {
    $route: "onLoadProvince",
  },
  computed: {
    /* eslint-disable */

    noEntryDataTable: function () {
      if (this.$store.state.textbook.notEntry != null) {
        return this.$store.state.textbook.notEntry;
      }
    },
    province: function () {
      if (this.$store.state.wins.province.Provinces_KH != null) {
        return this.$store.state.wins.province.Provinces_KH.sort(function (
          a,
          b
        ) {
          return a.pcode - b.pcode;
        });
      }
    },

    /* eslint-enable */
  },
  methods: {
    onLoadProvince: function () {
      this.$store.dispatch("wins/getWinsReport", {
        b_type: 1,
        c_code: "",
        acc_code: this.a_code,
      });
    },
    show_list: function (state) {
      // state is 0 not input, 1 invalid, 2 valid
      let proId = "";
      let rt = 0;
      if (
        typeof this.$refs.pro.selectedItems[0] !== "undefined" &&
        typeof this.$refs.report_type.selectedItems[0] !== "undefined"
      ) {
        proId = this.$refs.pro.selectedItems[0].pid; //get province id
        rt = this.$refs.report_type.selectedItems[0].value; //get the report type
        this.$store.dispatch("textbook/getEntryPrivate", {
          acc_code: this.a_code,
          pro_code: proId,
          rpt_code: rt,
          sta_code: state,
        });
      }
    },
    get_basicInfo: function () {
      let proId = "";
      if (
        typeof this.$refs.pro.selectedItem !== "undefined" ||
        typeof this.$refs.report_type.selectedItem !== "undefined"
      ) {
        proId = this.$refs.pro.selectedItem.pid; //get province id
        this.$store.dispatch("wins/getBasicASCFReport", {
          p_code: proId,
          a_code: this.a_code,
        });
      }
    },
  },
  mounted() {
    this.$refs.pro.lastItem = 25;
  },
  created() {
    if (!this.$store._modules.root._children[`wins`]) {
      // console.log('reg pre')
      this.$store.registerModule("wins", winsModule);
    }
    this.onLoadProvince();
  },
};
</script>

<style scoped>
.questionTitle {
  font-family: "Siemreap";
  font-size: 14px;
}
.starTitle {
  font-family: "Siemreap";
  font-size: 20px;
}
.categoryTitle {
  font-family: "Siemreap";
  font-weight: bold;
  font-size: 20px;
}
.v-list {
  height: 300px;
  overflow-y: auto;
}
</style>
